
import { post, get, put } from "../xhr";



export function accountSetup (data) {
    return post('/profile/set-up', 'multipart/form-data', data);
}

export function myProfile () {
    return get('/profile/', 'application/json')
}

export function updateProfile(data) {
    return put('/profile/update', 'application/json', data);
}

export function setup(data) {
    return post('/profile/update/setting', 'application/json', data);
}


export async function uploadAvatar(data) {
    const formData = new FormData();
    formData.append('avatar', data.file)
    return post('/profile/upload-avatar', 'multipart/form-data', data);
}